<template>
  <div class="modal fade" tabindex="-1" role="dialog" data-backdrop="" style="margin-top: 15%">
    <div class="modal-dialog">
      <div class="modal-content" style="background-color: rgb(216,236,247)">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" @click="handleCancel">&times;</span></button>
        </div>
        <div class="modal-body">
          <h4 style="color: #3F4C5C; text-align: center;" v-html="msg"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: ''
    },
    staticmessage: {
      type: String,
      default: ''
    }
  },
  computed: {
    msg() {
      if (this.message) {
        return this.$t(`message["${this.message}"]`)
      } else if (this.staticmessage) {
        return this.staticmessage
      } else {
        return ''
      }
    }
  },
  methods: {
    handleCancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/CommonDialog/index.vue